import { GeotiffModel } from "./Geotiff.model";

export class Geotiff extends GeotiffModel {
    // Add custom methods here
    addToMap = (map: mapboxgl.Map) => {
        const geotiffUrl = `mapbox://nickdreiling.${this.geotiffName}`;
        map.addSource(`${this.id}_geotiff`, {
            type: "raster",
            url: geotiffUrl,
        }).addLayer({
            id: `${this.id}_geotiff`,
            type: "raster",
            source: "geotiff",
        });
    };
}
